export default __webpack_public_path__ + "static/media/BeforePhoto13.17e13f35.JPG";